import ClaimDetails from './gadgetAgent/claimDetail';
import RegisteredCases from './gadgetAgent/registercases';
import preapproval from './gadgetAgent/preapproval';
import agentmis from './gadgetAgent/agentmis';
import networkApproval from './gadgetNetwork/networkApproval';
import upload from './gadgetNetwork/upload';
import serviceprovider from './gadgetNetwork/serviceProvider';
import approval from './gadgetNetwork/approval';
import caseReopen from './gadgetNetwork/caseReopen';
import eTAReminder from './gadgetNetwork/eTAReminder';
import excessfee from './gadgetNetwork/excessfees';
import bersettlement from './gadgetNetwork/bersettlement';
import networkmis from './gadgetNetwork/networkmis';
import IntimationMisTracker from './gadgetNetwork/intimationMisTracker';
import EscalationApproval from './gadgetNetwork/EscalationsApproval';
import userCreate from './gadgetAdmin/userCreate';
import dashboard from './autoSUperadmin/dashboard';

import { allMIS, downloadPicture, DuplicatedCalims, insurerBillingDashboard, reassignToVendor, resentLink } from './Allmenus';
import paymentHistory from './gadgetNetwork/paymentHistory';
import insurerBillingTable from './gadgetNetwork/insurerBillingTable';
import ExcessFeeSlabs from 'pages/extra-pages/Dataupload/ExcessFeeSlabs';
import insurerSummaryReport from './gadgetNetwork/insurerSummaryReport';
import feedbackCalling from './gadgetNetwork/feedbackCalling';
import UnListedClient from './gadgetAgent/unlistedClients';
import invoiceFin from './techFinance/invoiceFin';
import techFinDashboard from './autoSUperadmin/techFinDashboard';


const ALL_MENUS = [
  dashboard,
  insurerBillingDashboard,
  techFinDashboard,
  userCreate,
  ClaimDetails,
  RegisteredCases,
  // UnListedClient,
  DuplicatedCalims,
  excessfee,
  invoiceFin,
  paymentHistory,
  insurerBillingTable,
  insurerSummaryReport,
  feedbackCalling,
  resentLink,
  networkApproval,
  approval,
  reassignToVendor,
  serviceprovider,
  caseReopen,
  eTAReminder,
  bersettlement,
  downloadPicture,
  allMIS,
  upload,
  EscalationApproval,
  networkmis,
  IntimationMisTracker,
  agentmis,
];

const useMenuItems = () => {
  const userPermissionsTab = JSON.parse(
    localStorage.getItem("userPermission") || "[]"
  );

  const MatchedMenusTabs = ALL_MENUS
    ?.map((menu) => ({
      ...menu,
      children: (menu?.children || [])?.filter((child) =>
        userPermissionsTab.includes(child.id)
      ),
    }))
    ?.filter((menu) => menu?.children?.length > 0);

  return {
    items: MatchedMenusTabs,
  };
};

export default useMenuItems;
